export const IMAGE_ERROR_MESSAGE = "Choose the image";

export const CONFIRMED = "confirmed";
export const ACCEPT = "accept";
export const PENDING = "pending";
export const REJECT = "reject";
export const DECLINED = "declined";
export const CANCELED = "canceled";
export const FILE_MAX_SIZE = 5 * 1024 * 1024;
export const GIF_FILE_MAX_SIZE = 50 * 1024 * 1024;

export const SCROLL_DOWN = 1;
export const SCROLL_UP = -1;

export const requestMessages = {
  something_went_wrong: "Something went wrong",
};

export const ALL_FIELDS_REQUIRED = "All names required";

export const LANGUAGES = {
  arm: "hy",
  rus: "ru",
  eng: "en",
};

export const BENEFITS = "benefit";
export const CLIENTS_SECTION = "clients-section";
export const ITEM_SECTION = "item-section";
export const IMAGE_INFO = "infoImage";
export const FOOTER_SECTION = "footer-section";

export const ROUTES = {
  user_details: "/user-details",
  plan_details: "/plan-details",
};
export const USER_ID = "userId";
export const PLAN_ID = "planId";

export const BUTTONS_TYPE = {
  active: "activate",
  deactive: "deactivate",
  delete: "delete",
  edit: "edit",
  cancel: "cancel",
  save: "save",
};

export const BUTTON_VARIANTS = {
  contained: "contained",
};

const USER_STATUS = {
  PENDING: "pending",
  ACCEPTED: "active",
  REJECTED: "rejected",
  DEACTIVATED: "deactivated",
  DELETED: "deleted",
};

export const statusList = {
  1: USER_STATUS.PENDING,
  2: USER_STATUS.ACCEPTED,
  3: USER_STATUS.REJECTED,
  4: USER_STATUS.DEACTIVATED,
  5: USER_STATUS.DELETED,
};

export const HTTP_REQUEST_STATUS = {
  BAD_REQUEST: 400,
};

export const SOMETHING_WENT_WRONG = "Something went wrong";

export const ACTIVE = "Active";
export const DEACTIVATED = "Deactivated";

export const DEFAULT_REG_NUMBER = "-";

export const ACTIVE_STATUS_VALUE = 1;
export const INACTIVE_STATUS_VALUE = 0;
export const ACTIVE_STATUS = "activate";
export const INACTIVE_STATUS = "deactivate";
export const BRANCH_ERROR_MSG = "There are already created branches";
export const PROMO_CODE_ERROR_MSG = "Invalid promo code";
export const DEALER_CODE_ERROR_MSG = "Invalid dealer code";
export const AMBASSADOR_CODE_ERROR_MSG = "Invalid ambassador code";
export const CONTRACT_NUMBER_ERROR_MSG = "Invalid contract number";
export const BILLING_EMAIL_ERROR_MSG = "Invalid billing email";
export const BILLING_EXPIRATION_ERROR_MSG = "Failed to update billing expiration date";
export const PAGE_LANGUAGE = "page-lang";
export const FILE = "file";
export const GOODS = "goods";
export const LANGUAGES_ARRAY = ["hy", "ru", "en"];

export const MEASUREMENT_OPTIONS_TEMPORARY = [
  {
    id: 1,
    name_en: "Milliliters",
    name_ru: "Миллилитр",
    name_hy: "Միլիլիտր",
    value_en: "ML",
    value_ru: "МЛ",
    value_hy: "ՄԼ",
  },
  {
    id: 4,
    name_en: "Kilograms",
    name_ru: "Килограмм",
    name_hy: "Կիլոգրամ",
    value_en: "KG",
    value_ru: "КГ",
    value_hy: "ԿԳ",
  },
  {
    id: 3,
    name_en: "Pieces",
    name_ru: "Штуки",
    name_hy: "Կտորներ",
    value_en: "PC",
    value_ru: "ШТ",
    value_hy: "ՀՏ",
  },
];

export const MILLILITERS_VALUE = 1;
export const PEACE_VALUE = 3;

export const WEB_CONTENT_PATH = "/home";
export const EMAIL_ERROR_MESSAGE = "Invalid email";

export const NUMBER_REGEX = /[^0-9]/g;
export const NUMBER_DOT_REGEX = /[^0-9.]/g;
export const ONE_DOT_REGEX = /(\..*)\./g;

export const ORDER = "order";
export const ADD_ONE_TO_ORDER = 1;

export const STATUS_DROPDOWN = [
  {
    id: "active",
    name: "active",
  },
  {
    id: "inactive",
    name: "inactive",
  },
  {
    id: "scheduled",
    name: "scheduled",
  },
];

export const PLACEMENT_DROPDOWN = [
  {
    id: "goods_list_3rd",
    name: "goods_list_3rd_place",
  },
  {
    id: "goods_list_5th",
    name: "goods_list_5rd_place",
  },
  {
    id: "inventory_list_3rd",
    name: "inventory_list_3rd_place",
  },
  {
    id: "inventory_list_5th",
    name: "inventory_list_5rd_place",
  },
  {
    id: "advertisement_list",
    name: "advertisement_list",
  },
];

export const PLACEMENT_FILTER_DROPDOWN = [
  {
    id: "GL3",
    name: "goods_list_3rd_place",
  },
  {
    id: "GL5",
    name: "goods_list_5rd_place",
  },
  {
    id: "IL3",
    name: "inventory_list_3rd_place",
  },
  {
    id: "IL5",
    name: "inventory_list_5rd_place",
  },
  {
    id: "AL",
    name: "advertisement_list",
  },
];

export const GOOD_NUMBER_FIELDS = [
  "weight_full",
  "weight_empty",
  "goods_type_id",
  "litrage",
  "density",
];

export const REQUIRED_ERROR_MESSAGE = "This field is required";
export const ERROR_MESSAGE = "All fields are required";
